module.exports = __webpack_public_path__ + "static/media/emptyStates.bd0a2a52.svg";